import { render, staticRenderFns } from "./barra-lateral-agregar-pago.vue?vue&type=template&id=b163402a&scoped=true&"
import script from "./barra-lateral-agregar-pago.vue?vue&type=script&lang=ts&"
export * from "./barra-lateral-agregar-pago.vue?vue&type=script&lang=ts&"
import style0 from "./barra-lateral-agregar-pago.vue?vue&type=style&index=0&id=b163402a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b163402a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer,VTextField})
